import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'

export const WebsiteHyperlinkText = styled.p`
    ${cssMediaQueryBreakpoints.small} {
        font-size: 13px;
        margin-right: 0;
    }

    font-size: 14px;
    text-decoration: underline;
    color: ${p => p.theme.headerTextColor};
    opacity: 0.87;
    margin-right: 5px;
`
